// @ts-strict-ignore
import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {CallingApplication, PlayerMapping, RecorderMapping, Event, TabletMapping} from "@models";
import {EventEmitterService} from "@event-emitter";
import {SimEventService, SimPermissionService} from "@services";
import {environment} from "../../../../environments/environment";
import {fadeInOnEnterAnimation} from "angular-animations";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";
import {from, Observable} from "rxjs";

@Component({
	selector: "sim-welcome",
	templateUrl: "./welcome.component.html",
	styleUrls: ["./welcome.component.scss"],
	providers: [EventEmitterService],
	animations: [fadeInOnEnterAnimation({duration: 150})],
	standalone: false,
})
export class WelcomeComponent implements OnInit, OnChanges {
	T = Translations;

	@Input() playerInfo: PlayerMapping;
	@Input() commander: RecorderMapping | TabletMapping = null;
	baseHref = environment.baseHref;

	event$: Observable<Event>;

	today = new Date();

	CallingApplication = CallingApplication;

	constructor(
		private _eventEmitterService: EventEmitterService,
		private _simEventService: SimEventService,
		public translate: TranslateService,
		public permissionService: SimPermissionService,
	) {}

	public ngOnInit() {
		this.event$ = new Observable<Event>((subscriber) => {
			this._eventEmitterService.onEventsChanged.subscribe(async () => {
				const event = await this._simEventService.getEventByScenarioRecordingId(this.playerInfo?.info?.currentScenarioRecordingId);
				subscriber.next(event);
			});

			from(this._simEventService.getEventByScenarioRecordingId(this.playerInfo?.info?.currentScenarioRecordingId)).subscribe(
				(eventInfo) => subscriber.next(eventInfo),
			);
		});
	}

	public async ngOnChanges(changes: SimpleChanges) {}
}
